<template>
  <modal
    header
    :footer="true"
    disable-click-outside
    class="scorestream-modal"
    data-test="graphics-scorestreamConnectModal"
    auto-height
    @close="onCancel"
  >
    <!-- Header -->
    <template #modal-header>
      <h2>Setup your ScoreStream App</h2>
      <button
        class="modal-close"
        aria-label="Close modal"
        data-test="graphics-scorestreamConnectModal-close"
        @click="onCancel"
      >
        <span class="fa fa-times" />
      </button>
    </template>

    <!-- Body -->
    <template #modal-body>
      <div class="scorestream-modal__description">
        <label>
          Widget Type
          <select
            v-model="widgetType"
            class="width-full"
            data-test="graphics-scorestreamModal-widgetType"
            data-entity="graphics-scorestreamModal-widgetType"
          >
            <option value="">
              Select a widget type
            </option>
            <option value="vert">
              Vertical Scoreboard
            </option>
            <option value="banner">
              Banner Scoreboard
            </option>
            <option value="teamSchedule">
              Team Schedule
            </option>
          </select>
        </label>
      </div>

      <div class="scorestream-modal__description">
        <label>
          Widget ID
          <input
            v-model="widgetId"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            placeholder="Enter widget ID"
            data-test="graphics-scorestreamModal-widgetId"
            data-entity="graphics-scorestreamModal-widgetId"
            @input="validateNumericInput"
          >
        </label>
      </div>
    </template>

    <!-- Footer -->
    <template #modal-footer>
      <div class="display-flex items-center gap-1 flex-end">
        <button
          class="btn btn-style-b"
          data-test="graphics-scorestreamModal-cancel"
          @click="onCancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-style-a no-tooltip"
          :disabled="!isValid"
          data-test="graphics-scorestreamModal-connect"
          data-entity="graphics-scorestreamModal-connect"
          @click="onConnect"
        >
          Connect
        </button>
      </div>
    </template>
  </modal>
</template>
<script>
import Modal from './Modal.vue';

export default {
  emits: ['close', 'connect'],
  name: 'ScorestreamConnectModal',

  components: {
    Modal,
  },

  data() {
    return {
      widgetType: '',
      widgetId: '',
    };
  },

  computed: {
    isValid() {
      return this.widgetType && this.widgetId && /^\d+$/.test(this.widgetId);
    },
  },

  methods: {
    validateNumericInput(event) {
      // Remove any non-numeric characters
      const numericValue = event.target.value.replace(/[^0-9]/g, '');
      this.widgetId = numericValue;
      // eslint-disable-next-line no-param-reassign
      event.target.value = numericValue;
    },

    onCancel() {
      this.$emit('close');
    },

    onConnect() {
      if (!this.isValid) {
        return;
      }

      this.$emit('connect', {
        widgetType: this.widgetType,
        widgetId: this.widgetId,
      });

      this.onCancel();
    },
  },
};
</script>

<style lang="scss" scoped>
.scorestream-modal {
  &__description {
    margin-bottom: 1rem;

    label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 600;
    }

    input,
    select {
      display: block;
      width: 100%;
      margin-top: 0.5rem;
    }

    /* Hide number input spinners */
    input[type="text"][inputmode="numeric"] {
      /* Chrome, Safari, Edge, Opera */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      -moz-appearance: textfield;
    }
  }
}
</style>
